import { render, staticRenderFns } from "./ProjectsProgressCircle.vue?vue&type=template&id=166535c3&scoped=true&"
import script from "./ProjectsProgressCircle.vue?vue&type=script&lang=js&"
export * from "./ProjectsProgressCircle.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsProgressCircle.vue?vue&type=style&index=0&id=166535c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166535c3",
  null
  
)

export default component.exports